import Checkbox from "../Inputs/Checkbox/Checkbox";
import Form from "../Form";
import Texts from "../Inputs/Inputs.texts.all.js";
import Email from "../Inputs/Email/Email";
import Tel from "../Inputs/Tel/Tel";
import Select from "../Inputs/Select/Select";
import Radio from "../Inputs/Radio/Radio";
import File from "../Inputs/File/File";
import FormWarning from "./FormWarning";
import Hidden from "../Inputs/Hidden/Hidden";
import DateInput from "../Inputs/Date/Date";
import FormRating from "../Inputs/Rating/Rating";
import Number from "../Inputs/Number/Number";

const FormValidation = {
    warning: null,

    init(form) {
        if (!form.length) return;
        this.bind(form);
    },

    bind(form) {
        Texts.bind(form);
        Email.bind(form);
        Tel.bind(form);
        Select.bind(form);
        Checkbox.bind(form);
        Radio.bind(form);
        File.init(form);
        Hidden.bind(form);
        DateInput.bind(form);
        FormRating.bind(form);
        Number.init(form);

        form.find('button.clear').click((evt) => {
            Form.reset($(evt.currentTarget).closest('form'));
        })

        form.find('button.fill').click((evt) => {
            this.fill($(evt.currentTarget).closest('form'));
        })
    },

    check(form) {
        this.removeInvalid(form);
        let ok = true;
        ok &= Texts.check(form);
        ok &= Email.check(form);
        ok &= Tel.check(form);
        ok &= Select.check(form);
        ok &= Checkbox.check(form);
        ok &= Radio.check(form);
        ok &= Hidden.check(form);
        ok &= DateInput.check(form);
        ok &= FormRating.check(form);

        console.log(ok);

        if (ok) {
            FormWarning.hide(form);
            return true;
        } else {
            FormWarning.show(form);

            setTimeout(() => {
                $(form).find(".shake").removeClass("shake");
            }, 1000);

            // var firstInvalidTop = $(form).find('.invalid').first().offset().top;
            //
            // if (firstInvalidTop < $('body').scrollTop())
            //     $('body, html').animate({scrollTop: firstInvalidTop - 80}, 500)

            return false;
        }
    },

    removeInvalid(form) {
        form.find('.input').removeClass('invalid shake');
    },

    setValid(input, isValid, shake = false) {
        if (isValid) {
            input.closest('.input').removeClass('warning invalid shake').addClass('valid');
            setTimeout(()=>{
                input.closest('.input').removeClass('valid');
            }, 1000)
            if(!window.useDatalayer || !window.dataLayer_form.ecommerce) return;
            window.dataLayer_form.ecommerce.items[0][input.attr('name')] = input.val();
        } else {
            input.closest('.input').removeClass('valid').addClass('invalid');
            if(shake) input.closest('.input').addClass('shake');
            setTimeout(()=>{
                input.closest('.input').removeClass('invalid');
            }, 1000)
        }
    },
}

export default FormValidation;